import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { ToastrManager } from '@niceltd/sol/toastr';
import OverlayScrollbars from 'overlayscrollbars';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ShoppingCartService } from '../../../marketplace/agent-side/services/shopping-cart.service';
import { CvMarketplaceFilterComponent } from '../cv-marketplace-filter/cv-marketplace-filter.component';
import { CvMarketplaceShoppingCartHomeComponent } from '../cv-marketplace-shopping-cart-home/cv-marketplace-shopping-cart-home.component';
import { CvMarketplaceShoppingCartOrdersComponent } from '../cv-marketplace-shopping-cart-orders/cv-marketplace-shopping-cart-orders.component';
import { CvMarketplaceShoppingCartWishlistComponent } from '../cv-marketplace-shopping-cart-wishlist/cv-marketplace-shopping-cart-wishlist.component';
import { CvMarketplaceShoppingCartCarouselComponent } from '../cv-marketplace-shopping-cart-carousel/cv-marketplace-shopping-cart-carousel.component';
import { PointStorePermissionService } from 'src/app/gamification/marketplace/admin/services/point-store-permission.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { AliasPageName } from 'src/app/gamification/cv-marketplace-admin/models/gamification-pages.model';

@Component({
  selector: 'cv-marketplace-shopping-cart',
  templateUrl: './cv-marketplace-shopping-cart.component.html',
  styleUrls: ['./cv-marketplace-shopping-cart.component.scss']
})
export class CvMarketplaceShoppingCartComponent implements OnInit, OnDestroy {

  @ViewChild(CvMarketplaceShoppingCartHomeComponent) homeTab;
  @ViewChild(CvMarketplaceShoppingCartWishlistComponent) wishlistTab;
  @ViewChild(CvMarketplaceShoppingCartOrdersComponent) ordersTab;

  @Output() testFunction = new EventEmitter<any>();

  localizationStrings = new Map();
  pscs: any = null;
  filterMatchProduct: any = '';
  selectCategoriesTab = false;
  selectedTab = [
    { name: 'HOME', selected: true },
    { name: 'CATEGORIES', selected: false },
    { name: 'WISHLIST', selected: false },
    { name: 'ORDERS', selected: false },
  ];

  scrollOptions: OverlayScrollbars.PartialOptions = {
    scrollbars: {
      autoHide: "leave",
      autoHideDelay: 100,
      theme:"custom-scrollbar"
    },
    overflow: {
      x: 'hidden',
      y: 'visible-scroll'
    },
  };

  homeScrollOptions: OverlayScrollbars.PartialOptions = {
    scrollbars: {
      visibility: 'visible',
      autoHide: "leave",
      autoHideDelay: 100,
      theme:"custom-scrollbar"
    },
    overflow: {
      x: 'hidden',
      y: 'scroll'
    },
  };

  shouldRefreshTabs = true;

  highlightCartItem: boolean = false;
  lastAdded = null;
  loading: boolean = false;
  selectedVariation = null;
  isVariationSelected: boolean = true;
  drawerTimeOut = null;
  productQuantity: number = 1;

  @ViewChild('filters', { static: false })
  private childFilters: CvMarketplaceFilterComponent;

  @ViewChild('shoppingCartCarousel', { static: false })
  public shoppingCartCarouselComponent: CvMarketplaceShoppingCartCarouselComponent;

  hideOrdersTab: boolean = false;

  headerRightContentWidth: string = '';
  headerSearchBarWidth: string = '';
  @ViewChild('cvMarketplaceContainer') cvMarketplaceContainerER: ElementRef;
  cvMarketplaceContainerSize: number = 0;
  cvMarketplaceContainerObserver: any = null;
  
  isCxone: boolean = true;
  noPMLicense: boolean = null;
  
  constructor(
    private cvLocalizationService: CVLocalizationService,
    private shoppingCartService: ShoppingCartService,
    private cvNumberLocalize: CvNumberLocalizePipe,
    private changeDetector: ChangeDetectorRef,
    private renderer: Renderer2,
    private cvConfigurationService: CvConfigurationService,
    private toastrManager: ToastrManager,
    private pointStorePermissionService: PointStorePermissionService,
    private navSrvc: NavigationService
  ) {
    this.pscs = shoppingCartService.shoppingCartObj;
    cvConfigurationService.isCxOne = true;
    this.isCxone = cvConfigurationService.isCxOne;
  }

  async ngOnInit() {
    this.loadInitialFunctions();
    this.loadElementsContentWidth(true);
    await this.loadPermissionList();
    this.noPMLicense = !this.navSrvc.hasPartnerPMAccess;
  }

  ngOnDestroy(): void {
    if (this.cvMarketplaceContainerObserver) {
      this.cvMarketplaceContainerObserver.disconnect();
    }
  }

  async loadInitialFunctions() {
    this.pscs.shoppingCartShowLoader = true;
    this.loadLocalizations();
    await this.shoppingCartService.getAttributesInfo();
    await this.shoppingCartService.getUserLoginProfile();
    await this.shoppingCartService.getLandingInfo();
    await this.shoppingCartService.getSessionCart();
    await this.shoppingCartService.getFullLogin();
    await this.shoppingCartService.getCarouselItems();
    this.pscs.shoppingCartActiveTab = this.getLocalizationString('Home_Tab', 'HOME');
    this.changeTabNames();
    this.pscs.shoppingCartShowLoader = false;
    setTimeout(() => {
      //wait for rendering
      this.initCartDrawerFunctions();
    }, 500);
  }

  loadLocalizations() {
    this.cvLocalizationService.GetSection("MarketPlace").then((map) => {
      this.localizationStrings = map;
    });
  }

  getLocalizationString(key, defaultValue) {
    if (this.localizationStrings && this.localizationStrings.has(key))
      return this.localizationStrings.get(key);
    return defaultValue;
  }

  checkFilterLength(event) {
    this.showCategoriesTab();
    if (this.filterMatchProduct.length > 50) {
      this.filterMatchProduct = new String(this.filterMatchProduct.substring(0, 50));
    }
    this.pscs.shoppingCartFilter = this.filterMatchProduct.toString()
    this.shoppingCartService.filterShoppingCartProductByLabel(true);

    //hide product details and cart list
    this.pscs.pointStoreVisibleContent.showShoppingCartPage = false;
    this.pscs.shoppingCartIsProductSelected = false;
  }

  showCategoriesTab() {
    if (this.pscs.shoppingCartActiveTab == this.getLocalizationString('Items_Category_Tab', 'SHOP BY CATEGORY'))
      return;
    this.shouldRefreshTabs = false;
    this.selectedTab.forEach(element => {
      if (element.name == this.getLocalizationString('Items_Category_Tab', 'SHOP BY CATEGORY'))
        element.selected = true;
      else
        element.selected = false;
    });
    this.changeDetector.detectChanges();
    this.shouldRefreshTabs = true;
  }

  resetFilterLabel(showCategoriesTab = true) {
    if (showCategoriesTab)
      this.showCategoriesTab();
    this.filterMatchProduct = '';
    this.pscs.shoppingCartFilter = this.filterMatchProduct.toString();
    this.changeDetector.detectChanges();
    this.shoppingCartService.filterShoppingCartProductByLabel(true);
  }

  getResultsCount() {
    let count = 0;
    this.pscs.shoppingCartProducts.forEach(product => {
      if (product.showItem)
        count++;
    });
    return count;
  }

  getCurrentShoppingCart(): any {
    let cartQuantity = 0;
    cartQuantity = this.shoppingCartService.getCurrentCartQuantity();
    return cartQuantity > 99 ? '99+': cartQuantity;
  }

  showCart(isCartIconEvent: boolean) {
    if (this.pscs.pointStoreVisibleContent.showShoppingCartPage && !isCartIconEvent) {
      this.pscs.pointStoreVisibleContent.showShoppingCartPage = isCartIconEvent;
      this.hideShowTabSelected(false);

    } else if (!this.pscs.pointStoreVisibleContent.showShoppingCartPag && isCartIconEvent) {
      this.pscs.pointStoreVisibleContent.showShoppingCartPage = isCartIconEvent;
    }
  }

  deleteItemFromCart(product) {
    this.highlightCartItem = false;
    this.pscs.shoppingCartShowLoader = true;
    let tempShoppingCartObject = Object.assign({}, this.pscs);

    this.shoppingCartService.deleteItemFromCart(product)
      .then((result) => {
        if (this.pscs.pointStoreProductCarouselItems.findIndex((p) => { return p.PointStoreProductID === product.ProductID; }) > -1) {
          this.shoppingCartService.getCarouselItems();
          setTimeout(() => {
            if(this.shoppingCartCarouselComponent){
              this.shoppingCartCarouselComponent.displayDefaultImageByAction();
            }
          }, 50);
        }
        if (this.pscs.pointStoreDetailedViewProduct != null) {
          let currentProductUpdated = this.pscs.pointStoreProducts.find(p => p.PointStoreProductID == this.pscs.pointStoreDetailedViewProduct.PointStoreProductID);
          if (currentProductUpdated != null) {
            this.pscs.pointStoreDetailedViewProduct.Quantity = currentProductUpdated.Quantity;
          }
        }
        this.pscs.shoppingCartShowLoader = false;

        this.shoppingCartService.configureCurrentFilter(tempShoppingCartObject);
      });
  }

  goToCart() {
    // this.filterMatchProduct = '';
    this.pscs.pointStoreVisibleContent.showPopUpAddedCart = false;
    this.highlightCartItem = false;
    this.setCartDrawerVisible();
    this.setVisibleSections(false, false, false, false, true, false, false, false, false);
    this.hideShowTabSelected(true);
    if(this.isOrdersTabActive()){
      //hide orders tab
      this.hideOrdersTab = true;
    }
  }


  setCartDrawerVisible() {
    let drawerWidth = document.getElementById('cart-drawer');
    if (this.pscs.pointStoreVisibleContent.showPopUpAddedCart) {
      drawerWidth.style.opacity = "1";
      drawerWidth.style.zIndex = "100";
    } else {
      drawerWidth.style.opacity = "0";
      drawerWidth.style.zIndex = "-1";
    }
  }

  setVisibleSections(showPopUpDetails, showPopUpAddedCart, showLandingPage, showProductSectionLanding, showShoppingCartPage, showOrdersPage, showProductSectionFiltered, showPopUpBackground, showCheckoutMessage) {
    this.pscs.pointStoreVisibleContent.showLandingPage = showLandingPage;
    this.pscs.pointStoreVisibleContent.showProductSectionLanding = showProductSectionLanding;
    this.pscs.pointStoreVisibleContent.showProductSectionFiltered = showProductSectionFiltered;
    this.pscs.pointStoreVisibleContent.showShoppingCartPage = showShoppingCartPage;
    this.pscs.pointStoreVisibleContent.showPopUpAddedCart = showPopUpAddedCart;
    this.pscs.pointStoreVisibleContent.showPopUpDetails = showPopUpDetails;
    this.pscs.pointStoreVisibleContent.showOrdersPage = showOrdersPage;
    this.pscs.pointStoreVisibleContent.showPopUpBackground = showPopUpBackground;
    this.pscs.pointStoreVisibleContent.showCheckoutMessage = showCheckoutMessage;
  }


  addCartProduct() {
    this.timerFunction();
    this.setCartDrawerVisible();
    window.dispatchEvent(new Event('resize'));
  }

  timerFunction() {
    this.drawerTimeOut = setTimeout(() => {
      if ($('#cart-drawer:hover').length == 0 && this.pscs.pointStoreVisibleContent.showPopUpAddedCart) {
        this.pscs.pointStoreVisibleContent.showPopUpAddedCart = false;
        this.setCartDrawerVisible();
        this.highlightCartItem = false;
      } else if (this.pscs.pointStoreVisibleContent.showPopUpAddedCart) {
        this.timerFunction();
      }
    }, 20000);
  }

  resizeEventListener() {
    let cartDrawer = document.getElementById('cart-drawer');
    cartDrawer.style.top = '58px';
    // Cart drawer: 
    window.dispatchEvent(new Event('resize'));
    window.addEventListener('resize', (event) => {
      let nonparent = $('#store-cart-icon');
      let position = nonparent.offset();
      let drawerWidth = document.getElementById('cart-drawer').offsetWidth;
      let storeIcon = document.getElementById('store-cart-icon').offsetWidth;
      // let drawerRectangleWidth = document.getElementById('drawer-cart-icon').offsetWidth;
      $('#cart-drawer').offset({
        left: (position.left - drawerWidth) + storeIcon //+ drawerRectangleWidth
      });
      $('#drawer-cart-icon').offset({
        left: position.left
      });
    }, true);
  }

  clickListening() {
    //close orders or hide cart drawer
    this.renderer.listen('window', 'click', (e: Event) => {
      if (e.target['innerHTML'] != null) {
        this.hideCartDrawer(e);
        this.hideShoppingCartList(e);
      }
    });
  }

  //hide shopping cart list
  hideShoppingCartList(e: Event) {
    if (e.target['className'] == 'upper-tab' || e.target['className'] == 'upper-tab ng-star-inserted' ||
      e.target['className'] == 'upper-tab isActive' || e.target['className'] == 'upper-tab ng-star-inserted isActive') {

      this.showCart(false);
      // Did I click in the current active tab?
      if (!e.target['className'].includes('isActive')) {
        this.pscs.shoppingCartIsProductSelected = false;
        this.clearFilterShopByCategory();
      }
      //check if orders tab is actived
      if(this.isOrdersTabActive()){
        this.hideOrdersTab = false;
      }

    } else if (e.target['getAttribute']('ng-reflect-tooltip-content') != null) {
      if (e.target['getAttribute']('ng-reflect-tooltip-content') == this.getLocalizationString('Home_Tab', 'HOME') || e.target['getAttribute']('ng-reflect-tooltip-content') == this.getLocalizationString('Items_Category_Tab', 'SHOP BY CATEGORY') ||
        e.target['getAttribute']('ng-reflect-tooltip-content') == this.getLocalizationString('Wishlist_Tab', 'WISHLIST') || e.target['getAttribute']('ng-reflect-tooltip-content') == this.getLocalizationString('Orders_Tab', 'ORDERS')) {
        this.showCart(false);
        // Did I click in the current active tab?
        if (!e.target['parentElement']['className'].includes('isActive')) {
          this.pscs.shoppingCartIsProductSelected = false;
          this.clearFilterShopByCategory();
        }

        //check if orders tab is actived
        if(this.isOrdersTabActive()){
          this.hideOrdersTab = false;
        }

      }
    } else if ((e.target['className'] == 'tab-title' || e.target['className'] == 'tab-title ng-star-inserted') &&
      (e.target['innerHTML'] == this.getLocalizationString('Home_Tab', 'HOME') || e.target['innerHTML'] == this.getLocalizationString('Items_Category_Tab', 'SHOP BY CATEGORY') || e.target['innerHTML'] == this.getLocalizationString('Wishlist_Tab', 'WISHLIST') ||
        e.target['innerHTML'] == this.getLocalizationString('Orders_Tab', 'ORDERS'))
    ) {
      this.showCart(false);
      // Did I click in the current active tab?
      if (!e.target['parentElement']['parentElement']['className'].includes('isActive')) {
        this.pscs.shoppingCartIsProductSelected = false;
        this.clearFilterShopByCategory();
      }
      
      //check if orders tab is actived
      if(this.isOrdersTabActive()){
        this.hideOrdersTab = false;
      }
    }
  }

  //hide cart drawer
  hideCartDrawer(event) {
    let drawerElment = document.getElementById('cart-drawer');
    let $target = $(event.target);
    if (!$target.closest('#cart-drawer').length && !$target.parents('.drawer-delete-btn').length && drawerElment?.style.opacity == "1") {
      this.pscs.pointStoreVisibleContent.showPopUpAddedCart = false;
      this.highlightCartItem = false;
      this.setCartDrawerVisible();
      if (this.drawerTimeOut != null)
        clearTimeout(this.drawerTimeOut);
    }
  }

  initCartDrawerFunctions() {
    this.resizeEventListener();
    this.clickListening();
  }

  backToBrowse() {
    this.showCart(false);
    if(this.isOrdersTabActive()){
      this.hideOrdersTab = false;
    }
  }

  goToOrders() {
    let tab = document.getElementsByClassName('upper-tab')[3] as HTMLElement;
    tab.click();
    this.hideShowTabSelected(false);
    if(this.isOrdersTabActive()){
      this.hideOrdersTab = false;
    }
  }

  clearFilterShopByCategory(): void {
    this.filterMatchProduct = '';
    this.pscs.shoppingCartFilter = this.filterMatchProduct.toString();
    this.changeDetector.detectChanges();
    this.shoppingCartService.filterShoppingCartProductByLabel(true);
    if (this.childFilters) {
      this.childFilters.clearAll();
    }
  }

  showValidationMsg($event) {
    if ($event.isAdding)
      this.toastrManager.showToaster('success', this.getLocalizationString('Wishlist_Add', 'Product added to wishlist successfully.'));
    else
      this.toastrManager.showToaster('success', this.getLocalizationString('Wishlist_Remove', 'Removed from your wishlist.'));
  }

  hideShowTabSelected(statusTab: boolean): void{
    //statusTab = true => hide, false => show
    let tab = document.querySelector('.upper-tabs > .upper-tabs-header > .upper-tab.isActive');
    let tabSeparators = document.querySelectorAll('.upper-tabs > .upper-tabs-header > .upper-tab .separator');
    if(tab && tabSeparators){      
      let htmlTab = tab as HTMLElement;
      let htmlTabSeparators = tabSeparators as NodeListOf<Element>;
      if(statusTab){
        htmlTab.classList.add('cart-hide-active-tab');
        for (let e = 0; e < htmlTabSeparators.length; e++) {
          let element = htmlTabSeparators[e];
          element.classList.add('cart-display-separator-tab')
        }
      } else {
        let allTabs = document.querySelectorAll('.upper-tabs > .upper-tabs-header > .upper-tab');
        if(allTabs){
          let htmlAllTabs = allTabs as NodeListOf<Element>;
          for (let i = 0; i < htmlAllTabs.length; i++) {
            let element = htmlAllTabs[i];
            element.classList.remove('cart-hide-active-tab');
          }
        }
        for (let e = 0; e < htmlTabSeparators.length; e++) {
          let element = htmlTabSeparators[e];
          element.classList.remove('cart-display-separator-tab')
        }
      }
    }
  }

  callAndSetSelectedImage(){
    if(this.shoppingCartCarouselComponent){
      this.shoppingCartCarouselComponent.displayDefaultImageByAction();
    }
  }

  isOrdersTabActive(): boolean{
    let isActive = false;
    let tabsGroup = document.getElementsByClassName('upper-tab');
    if(tabsGroup){
      let ordersTab = tabsGroup[3];
      if(ordersTab){
        isActive = ordersTab.classList.contains('isActive');
      }
    }
    return isActive;
  }

  setHeaderSearchBarWidth(){
    if (this.cvMarketplaceContainerER) {
      if (this.cvMarketplaceContainerER.nativeElement.offsetWidth >= 1250) {
        this.headerSearchBarWidth = '250px';
      } else if (this.cvMarketplaceContainerER.nativeElement.offsetWidth <= 1249 && this.cvMarketplaceContainerER.nativeElement.offsetWidth >= 1124) {
        this.headerSearchBarWidth = '190px';
      } else if (this.cvMarketplaceContainerER.nativeElement.offsetWidth <= 1123 && this.cvMarketplaceContainerER.nativeElement.offsetWidth >= 995) {
        this.headerSearchBarWidth = '115px';
      } else {
        this.headerSearchBarWidth = '105px';
      }
    } else {
      this.headerSearchBarWidth = '250px';
    }
  }

  setHeaderRightContentWidth() {
    if (this.cvMarketplaceContainerER) {
      if (this.cvMarketplaceContainerER.nativeElement.offsetWidth >= 1380) {
        this.headerRightContentWidth = '620px';
      } else if (this.cvMarketplaceContainerER.nativeElement.offsetWidth <= 1379 && this.cvMarketplaceContainerER.nativeElement.offsetWidth >= 1250) {
        this.headerRightContentWidth = '520px';
      } else if (this.cvMarketplaceContainerER.nativeElement.offsetWidth <= 1249 && this.cvMarketplaceContainerER.nativeElement.offsetWidth >= 1124) {
        this.headerRightContentWidth = '440px';
      } else if (this.cvMarketplaceContainerER.nativeElement.offsetWidth <= 1123 && this.cvMarketplaceContainerER.nativeElement.offsetWidth >= 1025) {
        this.headerRightContentWidth = '370px';
      } else {
        this.headerRightContentWidth = '300px';
      }
    } else {
      this.headerRightContentWidth = '620px';
    }
  }

  loadElementsContentWidth(firstLoading: boolean) {
    if (firstLoading) {
      setTimeout(() => {
        this.setElementsContentWidth();
        this.configureResizeObserver();
      }, 0);
    } else {
      this.setElementsContentWidth();
    }
  }

  setElementsContentWidth() {
    this.setHeaderSearchBarWidth();
    this.setHeaderRightContentWidth();
    this.changeDetector.detectChanges();
    if (this.cvMarketplaceContainerER) {
      this.cvMarketplaceContainerSize = this.cvMarketplaceContainerER.nativeElement.offsetWidth;
    } else {
      this.cvMarketplaceContainerSize = 1;
    }
  }

  /**
   * configure resize observer
   */
  configureResizeObserver(){
    this.cvMarketplaceContainerObserver = new ResizeObserver(entries => {
      if (this.cvMarketplaceContainerER) {
        // Adjust the width of container to the width available.
        if (this.cvMarketplaceContainerER?.nativeElement?.offsetWidth !== 0 &&
          this.cvMarketplaceContainerSize !== 0 &&
          this.cvMarketplaceContainerER?.nativeElement?.offsetWidth !== this.cvMarketplaceContainerSize) {
            this.loadElementsContentWidth(false);
        }
      }
    });

    const divToObserve = document.getElementById('cv-marketplace-container');
    this.cvMarketplaceContainerObserver.observe(divToObserve);
  }
  changeTabNames() {
    this.selectedTab.forEach(tab => {
        switch (tab.name) {
            case 'HOME':
                tab.name = this.getLocalizationString('Home_Tab', 'HOME');
                break;
            case 'CATEGORIES' || 'SHOP BY CATEGORY':
                tab.name = this.getLocalizationString('Items_Category_Tab', 'SHOP BY CATEGORY');
                break;
            case 'WISHLIST':
                tab.name = this.getLocalizationString('Wishlist_Tab', 'WISHLIST');
                break;
            case 'ORDERS':
                tab.name = this.getLocalizationString('Orders_Tab', 'ORDERS');
                break;
        }
    });
  }

  /**
    * filter permission list to validate ui control
    * @param permission
    * @returns
    */
  hasPermission(permission: string): boolean {
    return this.pointStorePermissionService.checkPermission(permission,
      this.pointStorePermissionService.pageNameFilter(AliasPageName.Marketplace)
    );
  }

  async loadPermissionList() {
    await this.pointStorePermissionService.loadPermission(
      this.pointStorePermissionService.pageNameFilter(AliasPageName.Marketplace)
    );
  }
}
